import { render, staticRenderFns } from "./ResendEmailIcon.vue?vue&type=template&id=27450d26&"
import script from "./ResendEmailIcon.vue?vue&type=script&lang=js&"
export * from "./ResendEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports